import React from 'react'
import _ from 'lodash'
import styled from 'styled-components'

const Container = styled.label`
  font-weight: ${props => (props.items || props.bold) ? 900 : 400};
  word-wrap: break-word;
  cursor: pointer;

  @media (max-width: 450px) {
    font-size: 14px;
  }
`

export default ({ label, baseName, ...rest }) => (
  <Container {..._.omit(rest, 'enabled', 'filled')}>
    {label}
  </Container>
)
